module.exports = __webpack_public_path__ + "static/4.2_HandEmai_Icon-01-67b1f251f46cb105daec21301f882e57.png";